import { catalogApiFetch } from "../admin/jscontrol/apiClient";
import { getImageSrc, parseApiList } from "./productStorefront";

export const isBannerActive = (b) => {
  const active = b?.IsActive ?? b?.isActive;
  if (active === undefined || active === null) return true;
  return active === true || active === 1 || String(active).toLowerCase() === "true";
};

export const mapBannerToSlide = (b) => ({
  id: b.BannerId ?? b.bannerId,
  imageSrc: getImageSrc(b.ImageUrl ?? b.imageUrl ?? ""),
  alt: b.Title ?? b.title ?? "Banner",
  redirectUrl: String(b.RedirectUrl ?? b.redirectUrl ?? "").trim(),
  displayOrder: Number(b.DisplayOrder ?? b.displayOrder ?? 0),
});

export async function fetchActiveHeroBanners() {
  const params = new URLSearchParams({
    pageIndex: "1",
    pageSize: "100",
    search: "",
    sortColumn: "DisplayOrder",
    sortBy: "ASC",
  });

  try {
    const { data } = await catalogApiFetch(`/Banner/GetAll?${params}`);
    const items = parseApiList(data);
    return items
      .filter((b) => isBannerActive(b) && (b.ImageUrl || b.imageUrl))
      .sort((a, b) => (a.DisplayOrder ?? 0) - (b.DisplayOrder ?? 0))
      .map(mapBannerToSlide);
  } catch {
    return [];
  }
}
